import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

const STATSAPIURL = `${environment.baseEndpoint}/statsv2`;
const INDICATORS_API_URL_PHP = `${environment.baseEndpointPHP}/indicators/station/`;
const INDICATORS_LEGAL_API_URL_PHP = `${environment.baseEndpointPHP}/indicators`;

@Injectable({
  providedIn: 'root',
})
export class StatsService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getStats(stationId, awaitTo: boolean = true) {
    // tslint:disable-next-line: max-line-length
    if (awaitTo) {
      return this.myPromise.to(this.http.get(`${STATSAPIURL}/${stationId}`));
    }

    return this.myPromise.request(this.http.get(`${STATSAPIURL}/${stationId}`));
  }

  getStationsStats(userId, dependenceId, awaitTo = true) {
    // tslint:disable-next-line: max-line-length
    if (awaitTo) {
      return this.myPromise.to(this.http.get(`${STATSAPIURL}/user/${userId}/dependences/${dependenceId}`));
    }

    return this.myPromise.request(this.http.get(`${STATSAPIURL}/user/${userId}/dependences/${dependenceId}`));
  }

  getStationStatsMonthYear(stationId: any, monthReport: any, yearReport: any) {
    return this.myPromise.to(this.http.get(`${INDICATORS_API_URL_PHP}${stationId}/logbooks-month-year/${monthReport}/${yearReport}`));
  }

  getStationLogbooksPerYear(stationId: any, yearReport: any) {
    return this.myPromise.to(this.http.get(`${INDICATORS_API_URL_PHP}${stationId}/logbooks-year/${yearReport}`));
  }

  getCurrentLogbookStatsMonthYear(stationId: any, monthReport: any, yearReport: any) {
    return this.myPromise.to(this.http.get(`${INDICATORS_API_URL_PHP}${stationId}/logbooks-current-month-year/${monthReport}/${yearReport}`));
  }

  getLegalRequirementsByStationId(stationId: any, year: string) {
    return this.myPromise.to(this.http.get(`${INDICATORS_LEGAL_API_URL_PHP}/legal-requirements/station/${stationId}?start_date=${year}-01-01&end_date=${year}-12-21`));
  }
}
